<template>
  <div class="base-control pvc-tree">
    <pvc-tree-node
      class="tree-item"
      v-for="datum in data"
      :key="datum.id"
      :data="datum"
      :input="input"
      :totalPercentage="totalPercentage"
    ></pvc-tree-node>
  </div>
</template>

<script>

  import PvcTreeNode from './PvcTreeNode';

  export default {
    name: 'PvcTree',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      totalPercentage: {
        type: Number,
        default: 0
      },
      input: {
        type: [Boolean, Number],
        default: true
      }
    },
    data () {
      return {

      };
    },
    mounted () {

    },
    computed: {
      id () {
        return 'base-pvc-tree-' + this._uid;
      },
    },
    methods: {

    },
    components: {
      PvcTreeNode
    }
  };

</script>

<style>

</style>
